<!-- [PianoPlay](https://michaelecke.com/pianoplay) - Copyright (c) 2021 Rodrigo Jorge Vilar de Linares. -->

<ul class="set">
  <li *ngFor="let key of keys;let i = index" class="{{key}} {{keyStates[i]}}">{{keyFingers[i]}}</li>
</ul>